module.exports = __webpack_public_path__ + "static/media/underline.bedf9d18.svg";